// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"8973ab0c","498":"7c44afb5","513":"191b5a57","703":"b0402137"}[chunkId] + ".chunk.js";
};